// Countries for which we ship a preset MedicalVisitType catalog matching
// local occupational-health regulations. Shared source of truth for the DTO
// validation, the backend preset catalog keys, and the frontend country
// picker. 'OTHER' is a frontend-only pseudo-value (no preset, invites the
// admin to configure types manually / contact support) and never reaches
// the backend as a real country.
export const MEDICAL_VISIT_PRESET_COUNTRIES = [
  'FR',
  'DE',
  'BE',
  'NL',
  'IT',
  'ES',
  'PT',
  'GB',
  'US',
  'CA',
] as const;

export type MedicalVisitPresetCountry =
  (typeof MEDICAL_VISIT_PRESET_COUNTRIES)[number];
